export default __webpack_public_path__ + "static/media/javaScript.9ebf07a9.png";